// Analytics identifier capture for server-side conversion tracking.
//
// The booking flow hops through WhatsApp and may resume in a different
// browser, so GA4/Meta identifiers are captured here (while the original
// cookies still exist) and persisted on the Online Booking, where the
// backend uses them to send conversions via GA4 Measurement Protocol and
// Meta Conversions API.

function parse_cookies() {
	const cookies = {};
	for (const part of document.cookie.split("; ")) {
		if (!part) continue;
		const i = part.indexOf("=");
		if (i === -1) continue;
		cookies[part.slice(0, i)] = decodeURIComponent(part.slice(i + 1));
	}
	return cookies;
}

// _ga = "GA1.1.1234567890.1712345678" -> ga_client_id = "1234567890.1712345678"
function parse_ga_client_id(cookies) {
	if (!cookies._ga) return null;
	const parts = cookies._ga.split(".");
	if (parts.length < 4) return null;
	return parts.slice(-2).join(".");
}

// The session id lives in the per-stream _ga_<SUFFIX> cookie. The value
// format is undocumented and has already changed once (GS1.1 -> GS2.1), so
// parse tolerantly and return null rather than throw:
//   GS2.1: "GS2.1.s1712345678$o5$g1..." -> session id after ".s"
//   GS1.1: "GS1.1.1712345678.5.1..."    -> session id is the 3rd segment
function parse_session_cookie_value(value) {
	const match = value.match(/\.s(\d{9,11})/) || value.match(/^GS1\.1\.(\d{9,11})/);
	return match ? match[1] : null;
}

// _ga_* cookies live on the parent domain, so stale ones from other GA4
// streams (old containers, sibling sites) can coexist with the active one.
// Prefer the cookie matching the configured measurement ID; otherwise take
// the one with the most recent session id, since the active stream's cookie
// is the one still being updated.
function parse_ga_session_id(cookies) {
	const measurement_id = window.soma_ga4_measurement_id;
	if (measurement_id) {
		const value = cookies[`_ga_${measurement_id.replace(/^G-/, "")}`];
		if (value) return parse_session_cookie_value(value);
	}
	let newest = null;
	for (const key of Object.keys(cookies)) {
		if (!key.startsWith("_ga_")) continue;
		const session_id = parse_session_cookie_value(cookies[key]);
		if (session_id && (!newest || Number(session_id) > Number(newest))) {
			newest = session_id;
		}
	}
	return newest;
}

// If the Meta pixel hasn't set _fbc yet but the landing URL carries an
// fbclid, synthesize the fbc in Meta's documented format.
function parse_fbc(cookies) {
	if (cookies._fbc) return cookies._fbc;
	const fbclid = new URLSearchParams(window.location.search).get("fbclid");
	if (!fbclid) return null;
	return `fb.1.${Date.now()}.${fbclid}`;
}

// Returns a JSON string {ga_client_id, ga_session_id, fbp, fbc} with only
// the identifiers that could be captured, or null if none were found.
// Shape matches healthland_pos.booking.apply_tracking_ids.
export function get_tracking_ids() {
	try {
		const cookies = parse_cookies();
		const ids = {
			ga_client_id: parse_ga_client_id(cookies),
			ga_session_id: parse_ga_session_id(cookies),
			fbp: cookies._fbp || null,
			fbc: parse_fbc(cookies),
		};
		for (const key of Object.keys(ids)) {
			if (!ids[key]) delete ids[key];
		}
		return Object.keys(ids).length ? JSON.stringify(ids) : null;
	} catch (e) {
		// Tracking must never break checkout
		return null;
	}
}